import { useEffect, useState } from 'react';
import type { Descendant } from 'slate';
import { useThrottledCallback } from 'use-debounce';

import { slateToText } from 'src/lib/slate';
import { countChars, countWords } from 'src/lib/string';

const COUNTING_INTERVAL = 500;

const countValues = (value: Descendant[]) => {
  const plainText = slateToText(value).trim();
  return { characters: countChars(plainText), words: countWords(plainText) };
};

export const useDocumentCounters = (value: Descendant[]) => {
  const [counters, setCounters] = useState(() => countValues(value));

  const updateCounters = useThrottledCallback((nextValue: Descendant[]) => {
    setCounters(countValues(nextValue));
  }, COUNTING_INTERVAL);

  useEffect(() => {
    updateCounters(value);
  }, [updateCounters, value]);

  return counters;
};
